import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EndUserInstanceType } from "../types/EndUserInstanceType";
import { apiClient } from "src/utils/Api/apiClient";

interface endUserInstanceState {
        endUserInstance: EndUserInstanceType;
        endUserInstanceLoading: boolean;
        endUserInstanceError: string | null;
}

const initialState: endUserInstanceState = {
        endUserInstance: {
                Id: 0,
                EndUserInstanceId: "",
                EndUserId: 0,
                Name: "",
                NumberOfDoors: 0,
                Enabled: false,
                Notes: "",
                Link: "",
                CreatedAt: "",
        },
        endUserInstanceLoading: false,
        endUserInstanceError: null
}

export const createEndUserInstance = createAsyncThunk(
        'endUserInstance/createEndUserInstance',
        async (endUserInstanceData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.post('endUserInstance/createEndUserInstance', endUserInstanceData);
                        return response.data;
                } catch (endUserInstanceError: any) {
                        return rejectWithValue(endUserInstanceError.response.data || 'An error occured');
                }
        }
);

export const updateEndUserInstance = createAsyncThunk(
        'endUserInstance/updateEndUserInstance',
        async (endUserInstanceData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.post('endUserInstance/updateEndUserInstance', endUserInstanceData).then();
                        return response.data;
                } catch (endUserInstanceError: any) {
                        return rejectWithValue(endUserInstanceError.response.data || 'An error occured');
                }
        }
);

export const getEndUserInstanceById = createAsyncThunk(
        'endUserInstance/getEndUserInstanceById',
        async (endUserInstanceData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get(`endUserInstance/getEndUserInstanceByID/${endUserInstanceData}`);
                        return response.data;
                } catch (endUserInstanceError: any) {
                        return rejectWithValue(endUserInstanceError.response.data || 'An error occured');
                }
        }
);

const endUserInstanceSlice = createSlice({
        name: 'endUserInstance',
        initialState,
        reducers: {
                endUserInstanceReset: () => initialState,
        },
        extraReducers: (builder) => {
                //add endUsers to server
                builder.addCase(createEndUserInstance.pending, (state) => {
                        state.endUserInstanceLoading = true;
                        state.endUserInstanceError = null;
                });
                builder.addCase(createEndUserInstance.fulfilled, (state, action) => {
                        state.endUserInstanceLoading = false;
                        state.endUserInstance = action.payload;
                });
                builder.addCase(createEndUserInstance.rejected, (state, action) => {
                        state.endUserInstanceLoading = false;
                        state.endUserInstanceError = action.payload as string;
                });
                //update endUsers to server
                builder.addCase(updateEndUserInstance.pending, (state) => {
                        state.endUserInstanceLoading = true;
                        state.endUserInstanceError = null;
                });
                builder.addCase(updateEndUserInstance.fulfilled, (state, action) => {
                        state.endUserInstanceLoading = false;
                        state.endUserInstance = action.payload;
                });
                builder.addCase(updateEndUserInstance.rejected, (state, action) => {
                        state.endUserInstanceLoading = false;
                        state.endUserInstanceError = action.payload as string;
                });
                //get endUsers by ID from server
                builder.addCase(getEndUserInstanceById.pending, (state) => {
                        state.endUserInstanceLoading = true;
                        state.endUserInstanceError = null;
                });
                builder.addCase(getEndUserInstanceById.fulfilled, (state, action) => {
                        state.endUserInstanceLoading = false;
                        state.endUserInstance = action.payload;
                });
                builder.addCase(getEndUserInstanceById.rejected, (state, action) => {
                        state.endUserInstanceLoading = false;
                        state.endUserInstanceError = action.payload as string;
                });
        }
});

export const { endUserInstanceReset } = endUserInstanceSlice.actions;
export default endUserInstanceSlice.reducer;
